import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const Success = () => {
  const { t, lang } = useLang();
  const { state } = useLocation();
  const booking = state?.booking;

  return (
    <div
      className={`section ${lang === "hi" ? "font-devnagri" : ""}`}
      data-testid="success-page"
    >
      <div className="container-narrow max-w-2xl text-center">
        <div className="mx-auto mb-6 w-20 h-20 rounded-full flex items-center justify-center"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, rgba(212,166,74,0.35), rgba(212,166,74,0.05))",
            border: "1px solid rgba(212,166,74,0.55)",
          }}
        >
          <CheckCircle2 size={40} className="text-[color:var(--gold)]" />
        </div>

        <h1 className="font-display text-4xl md:text-5xl gold-text mb-4">
          {t.successTitle}
        </h1>
        <p className="text-[color:var(--cream)] opacity-90 mb-8 max-w-lg mx-auto">
          {t.successMsg}
        </p>

        {booking?.id && (
          <div className="card-glass p-6 mb-8 inline-block" data-testid="booking-id-card">
            <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--gold-soft)] mb-1">
              {t.bookingId}
            </div>
            <div className="font-mono text-[color:var(--gold)] text-lg break-all">
              {booking.id}
            </div>
          </div>
        )}

        <div>
          <Link to="/" className="btn-gold" data-testid="back-home-btn">
            {t.backToHome}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
